import { defineMessages } from 'react-intl-next';

export const trackChangesMessages = defineMessages({
	toolbarIconLabel: {
		id: 'editor.trackChanges.toolbarIconLabel',
		defaultMessage: 'Track Changes',
		description: 'Label for the track changes toolbar icon',
	},
});
